var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideBarLogoClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 323,
    viewBox: "0 0 320 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.1 89.7182C210.953 75.156 177.629 99.7237 177.629 113.026C177.639 152.617 246.772 196.721 261.1 195.13C279.522 193.083 314.971 156.678 319.435 141.912C323.528 128.373 305.512 102.615 261.1 89.7182Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0784 58.8999C72.5163 109.047 97.0839 142.372 110.386 142.372C149.976 142.362 194.081 73.2278 192.489 58.8999C190.442 40.4784 154.037 5.02924 139.272 0.564819C125.733 -3.52861 99.9751 14.4878 87.0784 58.8999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8998 232.933C109.047 247.495 142.371 222.928 142.371 209.625C142.361 170.035 73.2276 125.93 58.8998 127.522C40.4784 129.569 5.02942 165.974 0.565033 180.739C-3.52837 194.278 14.488 220.036 58.8998 232.933Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M230.294 263.739C244.857 213.591 220.289 180.267 206.987 180.267C167.396 180.277 123.292 249.411 124.884 263.739C126.931 282.16 163.336 317.609 178.101 322.074C191.64 326.167 217.398 308.151 230.294 263.739Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarLogoClose);
export default __webpack_public_path__ + "static/media/side_bar_logo_close.88484746ac1847e618b4ab6892376125.svg";
export { ForwardRef as ReactComponent };